export const CheckIcon = () => (
  <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" fill="currentColor" fillOpacity="0.1" r="32" />
    <circle cx="32" cy="32" fill="currentColor" r="24" />
    <path
      d="M26 32L30 36L38 28"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    />
  </svg>
);
